import React from 'react'

import LineLockAltIcon from 'components/Luxkit/Icons/line/LineLockAltIcon'
import Label from 'components/Luxkit/Label'

export type TripLabelVariant =
  | 'draft'
  | 'pending'
  | 'published'
  | 'customisable'

const configMap: Record<
  TripLabelVariant,
  React.ComponentProps<typeof Label>
> = {
  draft: {
    kind: 'secondary',
    variant: 'ghost',
    children: 'Draft',
    startIcon: null,
  },
  pending: {
    kind: 'tertiary',
    variant: 'warning',
    children: 'Sent for approval',
    startIcon: <LineLockAltIcon />,
  },
  published: {
    kind: 'tertiary',
    variant: 'success',
    children: 'Published',
    startIcon: <LineLockAltIcon />,
  },
  customisable: {
    kind: 'secondary',
    variant: 'ghost',
    children: 'Curated Trip',
  },
}

interface Props {
  variant: TripLabelVariant
  className?: string
}

function TripLabel(props: Props) {
  const { variant, ...rest } = props

  return <Label {...rest} {...configMap[variant]} />
}

export default React.memo(TripLabel)
